var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"variant":"success","show":!!_vm.message}},[_c('span',[_vm._v(" "+_vm._s(_vm.message)+" "),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }